/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Login_CancelInputs */



/**

* @param {_Login_CancelInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _login_cancel = /** @type {((inputs?: _Login_CancelInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Login_CancelInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Abbrechen")
});